"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const button_1 = require("@kyruus/button");
const tooltip_1 = __importDefault(require("@kyruus/tooltip"));
const ProviderReferralList_styles_1 = require("./ProviderReferralList.styles");
const SmartDrawer_1 = require("./SmartDrawer");
const MIN_ITEM_WIDTH = 200;
const ProviderReferralList = react_1.default.forwardRef((_a, ref) => {
    var { id, referrals, maxReferralCount, canRefer, hasReferrals, isReferDisabled, showSpinner, hideFields, track, onRemoveReferral, onSendReferralData, referralMetaData, labels: { finishButtonLabel = 'Finish and Close', finishButtonShortcutLabel = 'Shortcut: Shift + Alt + S', showMobileDrawerButtonLabel = 'Show referrals' } = {} } = _a, rest = __rest(_a, ["id", "referrals", "maxReferralCount", "canRefer", "hasReferrals", "isReferDisabled", "showSpinner", "hideFields", "track", "onRemoveReferral", "onSendReferralData", "referralMetaData", "labels"]);
    const showDrawer = canRefer && hasReferrals;
    const [mobileOpen, setMobileOpen] = react_1.default.useState(false);
    const handleOpenMobile = react_1.default.useCallback(() => {
        setMobileOpen(() => true);
    }, [setMobileOpen]);
    const handleCloseMobile = react_1.default.useCallback(() => {
        setMobileOpen(false);
    }, [setMobileOpen]);
    const handleRemoveReferral = react_1.default.useCallback((_event, data) => {
        if (onRemoveReferral) {
            onRemoveReferral(data);
        }
    }, [onRemoveReferral]);
    const handleFinishAndClose = react_1.default.useCallback(() => {
        if (onSendReferralData) {
            onSendReferralData(referralMetaData);
        }
        handleCloseMobile();
    }, [handleCloseMobile, onSendReferralData, referralMetaData]);
    const handleSaveShortcut = react_1.default.useCallback((e) => {
        if (e.shiftKey && e.altKey && e.code === 'KeyS' && showDrawer) {
            if (onSendReferralData) {
                onSendReferralData(referralMetaData);
            }
            handleCloseMobile();
        }
    }, [showDrawer, handleCloseMobile, onSendReferralData, referralMetaData]);
    react_1.default.useEffect(() => {
        document.addEventListener('keydown', handleSaveShortcut);
        return () => document.removeEventListener('keydown', handleSaveShortcut);
    }, [handleSaveShortcut]);
    return (react_1.default.createElement(SmartDrawer_1.SmartDrawer, Object.assign({ ref: ref }, rest, { open: { mobile: showDrawer && mobileOpen, desktop: showDrawer }, labels: { showMobileDrawerButtonLabel }, onOpenMobile: handleOpenMobile, onCloseMobile: handleCloseMobile, disabledMobileButton: !showDrawer }),
        react_1.default.createElement(ProviderReferralList_styles_1.ProviderCardList, { id: id, showCount: true, maxElements: maxReferralCount, showEmpty: maxReferralCount, minItemWidth: MIN_ITEM_WIDTH, providers: referrals, hideFields: hideFields, track: track, onRemoveReferral: handleRemoveReferral }),
        react_1.default.createElement(ProviderReferralList_styles_1.RelatedActionsContainer, null,
            react_1.default.createElement(tooltip_1.default, { title: finishButtonShortcutLabel, "aria-hidden": true },
                react_1.default.createElement(button_1.ButtonWithSpinner, { disabled: isReferDisabled, showSpinner: showSpinner, mode: "floating-primary", onClick: handleFinishAndClose, "aria-label": `${finishButtonLabel}, ${finishButtonShortcutLabel}` }, finishButtonLabel)))));
});
ProviderReferralList.displayName = 'ProviderReferralList';
exports.default = ProviderReferralList;
//# sourceMappingURL=ProviderReferralList.js.map